export default __webpack_public_path__ + "static/media/carousel2.e3afbb13.jpg";